export default __webpack_public_path__ + "static/media/register-as-coffee-shop-on-vegshelf.05690f64.png";